import type { ProjectType } from "@reno-estimator/core";

/** Sensible starting slider values so the user always has a plausible room size without typing. UI convenience only. */
export const DEFAULT_ROOM_SQFT: Partial<Record<ProjectType, number>> = {
  kitchen: 150,
  bathroom: 55,
  // Audit fix (Phase 7 audit): aligned to ENSUITE_SIZE_RANGES's "60-100
  // sq. ft." bucket's own representative value (80), rather than a
  // number (90) that didn't land on any bucket's representative sqft.
  ensuite: 80,
  basement: 800,
  basement_suite: 650,
  living_room: 300,
  family_room: 300,
  dining_room: 150,
  bedroom: 150,
  primary_bedroom: 200,
  laundry_room: 60,
  mudroom: 60,
  home_office: 120,
  garage: 400,
  entryway_foyer: 80,
  hallway: 60,
  attic: 400,
  whole_home_renovation: 1800,
  addition: 400,
  exterior: 1200,
  deck_patio: 250,
  other_custom: 200
};

export function defaultRoomSqft(projectType: ProjectType | null): number {
  if (!projectType) return 150;
  return DEFAULT_ROOM_SQFT[projectType] ?? 200;
}
